define("auth/routes/trial-plans", ["exports", "@ember/routing/route", "@ember/service"], function (_exports, _route, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let TrialPlansRoute = (_class = class TrialPlansRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "session", _descriptor, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);

      _initializerDefineProperty(this, "segmentEvents", _descriptor4, this);

      _initializerDefineProperty(this, "auth", _descriptor5, this);

      _initializerDefineProperty(this, "plans", _descriptor6, this);

      _initializerDefineProperty(this, "router", _descriptor7, this);

      _initializerDefineProperty(this, "userAgent", _descriptor8, this);
    }

    get hasActiveTrial() {
      return this.auth.currentAccount.hasActiveTrial;
    }

    redirect() {
      const targetPlan = this.subscriptions.getTargetPlan();

      if (targetPlan && targetPlan !== 'free') {
        // Remove from cache so that users can get back to
        //this route in the future without being redirected.
        this.subscriptions.removeTargetPlan();
        this.trackTrialOptIn(targetPlan);
        this.router.transitionTo('plans.plan', targetPlan, {
          queryParams: {
            isMonthly: false
          }
        });
      }

      if (this.hasActiveTrial || !this.auth.currentAccount.canTrialPlan) {
        var _this$auth$currentGro;

        this.router.transitionTo('cluster.schedule.calendar', (_this$auth$currentGro = this.auth.currentGroup) === null || _this$auth$currentGro === void 0 ? void 0 : _this$auth$currentGro.slug);
      }
    }

    activate() {
      this.segment.track('viewed-page', {
        page: 'opt_in_modal'
      });
    }

    beforeModel(transition) {
      this.session.requireAuthentication(transition, 'user.login');
    }

    async model() {
      const isMobile = !!this.userAgent.device.isMobile;
      const trialOptInPlans = await this.plans.trialOptInPlans(isMobile);
      return trialOptInPlans;
    }

    setupController(controller, model) {
      controller.set('trialOptInPlans', model);
    }

    trackTrialOptIn(planName) {
      var _this$auth$currentAcc;

      if ((_this$auth$currentAcc = this.auth.currentAccount) !== null && _this$auth$currentAcc !== void 0 && _this$auth$currentAcc.canTrialPlan) {
        const payload = {
          area: 'account_creation',
          location: null,
          profile: null,
          industry: null,
          bus_model: null,
          plan_name: planName
        };
        this.segmentEvents.trackWithGAIntegration('opted-in-for-trial', payload);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segmentEvents", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = TrialPlansRoute;
});